
import { Body } from '@vds/typography';
import React from 'react';
import styled from 'styled-components';
import { isTab,isMdot,isNative } from '../utils/globalConfig';


const MainDiv = styled.div`
margin-left: 2%;
margin-bottom: 16px;
display: flex;
width: ${isTab ? '290px' : '348px'};
height:${isMdot || isNative ? '162px' : '200px'};
padding: 16px 24px;
flex-direction: column;
align-items: flex-start;
gap: 16px;
border-radius: 16px;
border: 0px;
background-color: #f6f6f6;
`



export default function ConnectedDeviceDetails({connectedDevices}) {
    return (
        <React.Fragment>
            {connectedDevices &&
                <MainDiv >
                    <Body size="large" bold>{connectedDevices?.heading}</Body>
                    <Body size="large">{connectedDevices?.text}</Body>
                </MainDiv>}
        </React.Fragment>
        
    )

    

}